import styled from 'styled-components';

export const HeaderWrapper = styled.div<{ themeString?: string }>`
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  grid-template-rows: auto;
  grid-template-areas: 'TabSectionTitle TableTags TabSectionButton';
  padding: 18px 32px;
  background: ${(props) => props.theme.mainBackgorund};
  border-bottom: 2px solid ${(props) => props.theme.dividerMainColor};
  background: ${(props) => props.themeString !== 'dark' && 'white'};
`;

export const Title = styled.h1`
  grid-area: TabSectionTitle;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const TagsWrapper = styled.div`
  grid-area: TableTags;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  overflow-x: hidden;
  width: 100%;
  padding: 0px 32px;
`;
